import type { SVGProps } from "react";
export const WalletIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.83 14.106c0-1.212-.003-2.046-.087-2.672-.081-.605-.227-.903-.434-1.11-.208-.208-.506-.354-1.11-.435-.627-.085-1.46-.086-2.673-.086H5.171v5.144c0 1.212.002 2.046.086 2.672.081.605.227.903.434 1.11.208.208.506.354 1.11.435.627.084 1.46.086 2.673.086h5.052c1.212 0 2.046-.002 2.672-.086.605-.081.903-.227 1.11-.434.208-.208.354-.506.435-1.11.084-.627.086-1.46.086-2.673zm-2.079-.745a1.172 1.172 0 1 1-1.284 1.285l-.007-.12.007-.12c.06-.59.559-1.05 1.165-1.05zm-2.975-8.005a.607.607 0 0 0-.883-.539l-6.78 3.486h7.663zm1.5 2.947c.835.003 1.54.02 2.122.098.771.104 1.439.33 1.971.862s.757 1.2.86 1.97c.101.75.1 1.703.1 2.872v.842c0 1.17.001 2.123-.1 2.872-.103.771-.327 1.439-.86 1.971-.532.533-1.2.757-1.97.86-.75.101-1.703.1-2.873.1H9.474c-1.17 0-2.123.001-2.872-.1-.772-.103-1.439-.327-1.971-.86-.533-.532-.757-1.2-.86-1.97-.101-.75-.1-1.703-.1-2.873V9.051c0-.724.405-1.388 1.049-1.719l7.487-3.849a2.107 2.107 0 0 1 3.07 1.873z"
    />
  </svg>
);
